/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type DeleteApiWorkspaceServiceV1WorkspacesIdRequest = {
  id: string;
};

export type DeleteApiWorkspaceServiceV1WorkspacesIdResponseBody = {
  success?: boolean | undefined;
};

/** @internal */
export const DeleteApiWorkspaceServiceV1WorkspacesIdRequest$inboundSchema:
  z.ZodType<
    DeleteApiWorkspaceServiceV1WorkspacesIdRequest,
    z.ZodTypeDef,
    unknown
  > = z.object({
    id: z.string(),
  });

/** @internal */
export type DeleteApiWorkspaceServiceV1WorkspacesIdRequest$Outbound = {
  id: string;
};

/** @internal */
export const DeleteApiWorkspaceServiceV1WorkspacesIdRequest$outboundSchema:
  z.ZodType<
    DeleteApiWorkspaceServiceV1WorkspacesIdRequest$Outbound,
    z.ZodTypeDef,
    DeleteApiWorkspaceServiceV1WorkspacesIdRequest
  > = z.object({
    id: z.string(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace DeleteApiWorkspaceServiceV1WorkspacesIdRequest$ {
  /** @deprecated use `DeleteApiWorkspaceServiceV1WorkspacesIdRequest$inboundSchema` instead. */
  export const inboundSchema =
    DeleteApiWorkspaceServiceV1WorkspacesIdRequest$inboundSchema;
  /** @deprecated use `DeleteApiWorkspaceServiceV1WorkspacesIdRequest$outboundSchema` instead. */
  export const outboundSchema =
    DeleteApiWorkspaceServiceV1WorkspacesIdRequest$outboundSchema;
  /** @deprecated use `DeleteApiWorkspaceServiceV1WorkspacesIdRequest$Outbound` instead. */
  export type Outbound =
    DeleteApiWorkspaceServiceV1WorkspacesIdRequest$Outbound;
}

export function deleteApiWorkspaceServiceV1WorkspacesIdRequestToJSON(
  deleteApiWorkspaceServiceV1WorkspacesIdRequest:
    DeleteApiWorkspaceServiceV1WorkspacesIdRequest,
): string {
  return JSON.stringify(
    DeleteApiWorkspaceServiceV1WorkspacesIdRequest$outboundSchema.parse(
      deleteApiWorkspaceServiceV1WorkspacesIdRequest,
    ),
  );
}

export function deleteApiWorkspaceServiceV1WorkspacesIdRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  DeleteApiWorkspaceServiceV1WorkspacesIdRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      DeleteApiWorkspaceServiceV1WorkspacesIdRequest$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'DeleteApiWorkspaceServiceV1WorkspacesIdRequest' from JSON`,
  );
}

/** @internal */
export const DeleteApiWorkspaceServiceV1WorkspacesIdResponseBody$inboundSchema:
  z.ZodType<
    DeleteApiWorkspaceServiceV1WorkspacesIdResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    success: z.boolean().optional(),
  });

/** @internal */
export type DeleteApiWorkspaceServiceV1WorkspacesIdResponseBody$Outbound = {
  success?: boolean | undefined;
};

/** @internal */
export const DeleteApiWorkspaceServiceV1WorkspacesIdResponseBody$outboundSchema:
  z.ZodType<
    DeleteApiWorkspaceServiceV1WorkspacesIdResponseBody$Outbound,
    z.ZodTypeDef,
    DeleteApiWorkspaceServiceV1WorkspacesIdResponseBody
  > = z.object({
    success: z.boolean().optional(),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace DeleteApiWorkspaceServiceV1WorkspacesIdResponseBody$ {
  /** @deprecated use `DeleteApiWorkspaceServiceV1WorkspacesIdResponseBody$inboundSchema` instead. */
  export const inboundSchema =
    DeleteApiWorkspaceServiceV1WorkspacesIdResponseBody$inboundSchema;
  /** @deprecated use `DeleteApiWorkspaceServiceV1WorkspacesIdResponseBody$outboundSchema` instead. */
  export const outboundSchema =
    DeleteApiWorkspaceServiceV1WorkspacesIdResponseBody$outboundSchema;
  /** @deprecated use `DeleteApiWorkspaceServiceV1WorkspacesIdResponseBody$Outbound` instead. */
  export type Outbound =
    DeleteApiWorkspaceServiceV1WorkspacesIdResponseBody$Outbound;
}

export function deleteApiWorkspaceServiceV1WorkspacesIdResponseBodyToJSON(
  deleteApiWorkspaceServiceV1WorkspacesIdResponseBody:
    DeleteApiWorkspaceServiceV1WorkspacesIdResponseBody,
): string {
  return JSON.stringify(
    DeleteApiWorkspaceServiceV1WorkspacesIdResponseBody$outboundSchema.parse(
      deleteApiWorkspaceServiceV1WorkspacesIdResponseBody,
    ),
  );
}

export function deleteApiWorkspaceServiceV1WorkspacesIdResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<
  DeleteApiWorkspaceServiceV1WorkspacesIdResponseBody,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      DeleteApiWorkspaceServiceV1WorkspacesIdResponseBody$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'DeleteApiWorkspaceServiceV1WorkspacesIdResponseBody' from JSON`,
  );
}
